/**
 * TanStack Query hooks for `performance-tier-badges-for-affiliates`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	performanceTierBadgesForAffiliatesQueryKeys,
	type CreatePerformanceTierBadgesForAffiliatesBody,
	type ListPerformanceTierBadgesForAffiliatesResponse,
	type PerformanceTierBadgesForAffiliatesRow,
} from "./api";

export function usePerformanceTierBadgesForAffiliatesList(): UseQueryResult<ListPerformanceTierBadgesForAffiliatesResponse, Error> {
	return useQuery({
		queryKey: performanceTierBadgesForAffiliatesQueryKeys.list(),
		queryFn: list,
	});
}

export function usePerformanceTierBadgesForAffiliatesCreate(): UseMutationResult<PerformanceTierBadgesForAffiliatesRow, Error, CreatePerformanceTierBadgesForAffiliatesBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: performanceTierBadgesForAffiliatesQueryKeys.all });
		},
	});
}

export function usePerformanceTierBadgesForAffiliatesDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: performanceTierBadgesForAffiliatesQueryKeys.all });
		},
	});
}
